import { useConvexAction, useConvexMutation } from '@convex-dev/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { api } from '~/convex/_generated/api';
import type { Id } from '~/convex/_generated/dataModel';

interface UseReportRegenerateOptions {
  reportId: Id<'reports'>;
}

export function useReportRegenerate({ reportId }: UseReportRegenerateOptions) {
  const { t } = useTranslation();

  const { mutateAsync: markLifecycleState } = useMutation({
    mutationFn: useConvexMutation(api.reports.markReportLifecycleState),
  });

  const { mutateAsync: exportDoc, isPending: isRegenerating } = useMutation({
    mutationFn: useConvexAction(api.reportActions.exportDocument),
    onError: () => {
      toast.error(t('errors:errorGeneratingReport'));
    },
  });

  const regenerate = async () => {
    await markLifecycleState({ id: reportId, status: 'generating' });
    await exportDoc({ reportId });
  };

  return { regenerate, isRegenerating };
}
